import clsx from "clsx";
import * as React from "react";
import spriteHref from "~/js/components/spriteHref";

// Every React icon comes through here, so this is the one place that has to resolve the sprite.
// Icons written in Razor are repointed server-side by SvgSpriteUseTagHelper, but these are built
// in the browser, where a bare "#icon" would look for a sprite that is no longer in the document.
const SharedIcon = React.forwardRef(
  ({ className, children, iconName, ...props }, ref) => {
    const href = iconName ? spriteHref(iconName.replace(/^#/, "")) : iconName;

    return (
      <svg ref={ref} className={clsx("icon", className)} {...props}>
        <use href={href} xlinkHref={href}></use>
      </svg>
    );
  }
);

export { SharedIcon };
